import { castInto } from './helper';
export function scrollIntoParentViewHorizontal(child) {
    var scrollParent = child.parentElement;
    var scrollLeft = scrollParent.scrollLeft, parentWidth = scrollParent.offsetWidth;
    var childLeft = child.offsetLeft, childWidth = child.offsetWidth;
    var nextSrollLeft = scrollLeft;
    if (childLeft + childWidth > scrollLeft + parentWidth) {
        nextSrollLeft = childLeft + childWidth - parentWidth;
    }
    if (childLeft < scrollLeft) {
        nextSrollLeft = childLeft;
    }
    if (nextSrollLeft !== scrollLeft) {
        horizontalScrollElementWithAnimation(scrollParent, scrollLeft, nextSrollLeft);
    }
    return nextSrollLeft;
}
export function horizontalScrollContainerBy(container, deltaX) {
    var scrollLeft = container.scrollLeft, scrollWidth = container.scrollWidth, offsetWidth = container.offsetWidth;
    var targetLeft = castInto(scrollLeft + deltaX, [0, scrollWidth - offsetWidth]);
    horizontalScrollElementWithAnimation(container, scrollLeft, targetLeft);
}
function horizontalScrollElementWithAnimation(element, fromScrollLeft, toScrollLeft) {
    if (Math.abs(fromScrollLeft - toScrollLeft) < 1) {
        return;
    }
    requestAnimationFrame(function () {
        var nextScrollLeft = fromScrollLeft + (toScrollLeft - fromScrollLeft) / 3;
        var nextScrollLeftFixed = toScrollLeft > fromScrollLeft ? Math.ceil(nextScrollLeft) : Math.floor(nextScrollLeft);
        element.scrollLeft = nextScrollLeftFixed;
        horizontalScrollElementWithAnimation(element, nextScrollLeftFixed, toScrollLeft);
    });
}
